import { Component, inject } from "@angular/core";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { LoaderStore } from "../../store/loader.store";

@Component({
  selector: "zelo-loader",
  imports: [NzSpinModule],
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.css"
})
export class LoaderComponent {
  protected readonly loaderStore = inject(LoaderStore);
}
